import axios from 'axios';
import { auth } from './firebase'; // Import auth from your config

const API_BASE_URL = 'https://api-amg2dwk5ga-uc.a.run.app';

export const callApi = async (route, method, body = {}) => {
  try {
    const user = auth.currentUser;
    let token = null;

    if (user) {
      // Get the user's ID token
      token = await user.getIdToken();
    }

    // Include the token in the Authorization header
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };

    const config = {
      method,
      url: `${API_BASE_URL}${route}`,
      headers,
      data: body,
    };
    
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.error("API call failed:", error.response?.data || error.message);
    throw new Error(error.response?.data?.message || 'An API error occurred.');
  }
};